







import Vue from 'vue'
import store from '@/store'
import bus from '@/services/bus'
import User from '@/models/Users/User'

export default Vue.extend({
  props: {
    id: String
  },
  data () {
    return {
      tabs: [
        {label: this.$t('polls.poll'), name: 'pollPageInfo'},
        {label: this.$t('polls.recepients'), name: 'pollPageRcpts'},
        {label: this.$t('polls.results'), name: 'pollPageResult'}
      ],
      interval: null
    }
  },
  computed: {
    activeTab: {
      get (): string {
        return this.$route.name!
      },
      set () {

      }
    },
    user (): User | false {
      return this.$store.state.user.user
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('poll/get', to.params.id)
      // @ts-ignore
      bus.$emit('pathChanged')
      next()
    } catch (error) {
      console.error('LOG: beforeRouteEnter -> error', error)
      next('notFound')
    }
  },
  methods: {
    dataWatcher (): void {
      // @ts-ignore
      let self = this;
      // @ts-ignore
      self.interval = setInterval(() => {
        if (this.user) {
          // @ts-ignore
          self.reloadMailing();
        }
      }, 2000)
    },
    reloadMailing (): void {
      this.$store.dispatch('poll/get', this.id)
    },
    clearInterval (): void {
      // @ts-ignore
      clearInterval(this.interval)
    }
  },
  mounted () {
    this.dataWatcher();
    this.$root.$on('relogin', this.clearInterval)
  },
  beforeDestroy () {
    this.clearInterval()
    this.$root.$off('relogin', this.clearInterval)
  }
})
